<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      v-if="showForm.basic"
      :close-on-click-modal="false"
      :title="title"
      width="70%"
      @close="close"
    >
      <vab-query-form class="vab-query-form">
        <vab-query-form-left-panel :span="4">
        </vab-query-form-left-panel>
        <vab-query-form-right-panel :span="20">
          <el-form :inline="true" :model="queryForm" @submit.prevent>
            <el-form-item label="">
              <el-input
                v-model.trim="queryForm.keyword"
                class="pr-10"
                clearable
                placeholder="关键词"
              />
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="queryForm.command" class="pr-10" placeholder="操作类型" clearable>
                <el-option
                  v-for="item in commandOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" class="pr-10">
              <el-date-picker
                v-model="queryForm.startTime"
                type="datetime"
                placeholder="开始时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-date-picker
                v-model="queryForm.endTime"
                type="datetime"
                placeholder="结束时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="primary" @click="queryData">
                查询
              </el-button>
              <el-button icon="el-icon-download" type="warning" :loading="exportLoading" @click="exportData">
                导出
              </el-button>
            </el-form-item>
          </el-form>
        </vab-query-form-right-panel>
      </vab-query-form>
      <el-table v-loading="listLoading" stripe :data="list">
        <el-table-column align="left" label="序号" width="55">
          <template #default="{ $index }">
            {{ $index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="使用人"
          prop="basic.profile.avatar"
          width="80"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            <el-avatar shape="square" :size="32" :src="row.basic.profile.avatar"></el-avatar>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="使用人昵称"
          prop="basic.profile.name"
          show-overflow-tooltip
        />
        <el-table-column
          align="left"
          label="操作类型"
          prop="basic.command"
          :formatter="formatCommand"
          show-overflow-tooltip
        />
        <el-table-column
          align="left"
          label="按摩位置"
          prop="basic.place"
          :formatter="formatPlace"
          show-overflow-tooltip
        />
        <el-table-column
          align="left"
          label="按摩力度"
          prop="basic.power"
          :formatter="formatPower"
          show-overflow-tooltip
        />
        <el-table-column
          align="left"
          label="开始时间"
          prop="basic.startTime"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            {{ row.basic.startTime && moment(row.basic.startTime).format('YYYY-MM-DD HH:mm:ss') || '' }}
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="预计结束时间"
          prop="basic.closeTime"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            {{ row.basic.closeTime && moment(row.basic.closeTime).format('YYYY-MM-DD HH:mm:ss') || '' }}
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="实际结束时间"
          prop="basic.realCloseTime"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            {{ row.basic.realCloseTime && moment(row.basic.realCloseTime).format('YYYY-MM-DD HH:mm:ss') || '' }}
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="操作时间"
          prop="created"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </el-table-column>
        <template #empty>
          <el-image
            class="vab-data-empty"
            :src="require('@/assets/empty_images/data_empty.png')"
          />
        </template>
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.page"
        :layout="layout"
        :page-size="queryForm.size"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />

      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import config from './config'
import { findDevice, findDeviceRecordList, exportDeviceRecord } from '@/api/alfmeier'
export default {
  name: 'AlfmeierDeviceRecord',
  emits: ['fetch-data'],
  data() {
    return {
      moment,
      showForm: {},
      list: [],
      total: 0,
      layout: 'total, sizes, prev, pager, next, jumper',
      listLoading: true,
      exportLoading: false,
      row: {},
      dialogFormVisible: false,
      commandOptions: config.commands,
      queryForm: {
        deviceId: '',
        page: 1,
        size: 10,
        startTime: '',
        endTime: '',
        keyword: ''
      },
    }
  },
  methods: {
    formatPlace(row) {
      const find = config.places.find(e => e.value == row.basic.place)
      return find && find.label || '未知'
    },
    formatPower(row) {
      const find = config.powers.find(e => e.value == row.basic.power)
      return find && find.label || '未知'
    },
    formatCommand(row) {
      const find = config.commands.find(e => e.value == row.basic.command)
      return find && find.label || '未知'
    },
    async showRecord(row) {
      const deviceId = row.deviceId
      this.row = row
      const data = await findDevice({
        deviceId,
        simple: 1,
      })
      this.title = data.title
      this.showForm = data
      this.queryForm.deviceId = deviceId
      this.dialogFormVisible = true
      this.queryData()
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const data = Object.assign({}, this.queryForm)
      if(data.startTime)
        data.startTime = data.startTime.valueOf()
      if(data.endTime)
        data.endTime = data.endTime.valueOf()
      const { list, total } = await findDeviceRecordList(data)
      this.list = list
      this.total = total
      this.listLoading = false
    },
    async exportData() {
      this.exportLoading = true
      const data = Object.assign({}, this.queryForm)
      if(data.startTime)
        data.startTime = data.startTime.valueOf()
      if(data.endTime)
        data.endTime = data.endTime.valueOf()
      const ret = await exportDeviceRecord(data)
      this.exportLoading = false
      if(ret && ret.url){
        this.$alert(`下载地址：${ret.url}`, '设备记录导出', {
          confirmButtonText: '立即下载',
          callback: action => {
            window.location.href = ret.url
          }
        })
      }
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
.pr-10 {
  padding-right: 10px;
}
.vab-query-form {
  padding: 0;
}
</style>
